import {
  EmployeeLicenseStatus,
  EmployeeLicenseWarning,
  Language,
  States,
} from '../enums';
import { EmployeeLicense } from './EmployeeLicense';
import { EmployeeMinimal } from './EmployeeMinimal';
import { make, makeArray, makeEnums } from './Model';

export class EmployeeLicenseItem {
  compactLicense?: EmployeeLicense;

  employee: EmployeeMinimal;

  lead: EmployeeMinimal;

  languages?: Language[];

  stateLicenses?: EmployeeLicense[];

  stateOfResidence?: States;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.compactLicense = make(obj.compactLicense, EmployeeLicense);
    this.employee = make(obj.employee, EmployeeMinimal);
    this.languages = makeEnums(obj.languages, Language);
    this.lead = make(obj.lead, EmployeeMinimal);
    this.stateLicenses = makeArray(
      obj.stateLicenses,
      EmployeeLicense,
    )?.toSorted(EmployeeLicense.sortByStatus);
    this.stateOfResidence = States.byKey[obj.stateOfResidence];
  }

  get activeLicenses() {
    return [this.compactLicense, ...(this.stateLicenses || [])]
      .filter(Boolean)
      .filter(
        (item) =>
          ![
            EmployeeLicenseStatus.INACTIVE,
            EmployeeLicenseStatus.INACTIVE_DUE_PSOR,
          ].includes(item?.status as EmployeeLicenseStatus),
      );
  }

  get warning() {
    return [
      this.compactLicense?.warning,
      ...(this.stateLicenses || []).map(({ warning }) => warning),
    ]
      .filter(Boolean)
      .sort(EmployeeLicenseWarning.sortType)[0];
  }
}

export default EmployeeLicenseItem;
